import React, {useEffect, useState} from "react";
import "./index.css";
import {Link} from "react-router-dom";
import {Logout} from "../services/loginService";

// Navigation bar for HomePage.
const HomeNavBar = ({user}) => {

    const printUser = () => {
        console.log("Print is called")
        if(user)
            return user;
        else
            return "Login"
    }

    function logOutUser() {

        Logout()
        window.location.reload();
    }

    return (
        <header className="header sticky-top">
            <nav className="navbar navbar-expand-lg navbar-light bg-white py-3 shadow-sm">
                <div className="container"><Link className="navbar-brand" to="/home">
                    <strong className="h6 mb-0 font-weight-bold text-uppercase">Food Mafia</strong></Link>
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item active">
                            {/*If user has logged in then display USERNAME and link it to profile screen*/}
                            {
                                printUser() !== 'Login' && <a className="nav-link" href="/userProfile">{printUser()} <span
                                    className="sr-only">(current)</span></a>
                            }

                            {/*If user is NOT logged in then display LOGIN and link it to login screen*/}
                            {
                                printUser() === 'Login' && <a className="nav-link" href="/login">Login <span
                                    className="sr-only">(current)</span></a>
                            }
                        </li>
                        <li>
                            {/*If user has logged in then display LOGOUT option.*/}
                            {
                                printUser() !== 'Login' && <button className="btn btn-light" onClick={logOutUser}>Logout</button>
                            }

                            {/*If user is NOT logged in then display REGISTER option*/}
                            {
                                printUser() === 'Login' && <a className="nav-link" href="/register">Register <span
                                    className="sr-only">(current)</span></a>
                            }
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
    );
};

export default HomeNavBar;